/**
 * Check if dom node is descendant of another
*/

function isDescendant(parent, target) {
  if (parent === target) {
    return true;
  }

  let containsChild = false;
  for (let child of parent.children) {
    containsChild = isDescendant(child, target);

    if (containsChild) {
      break;
    }
  }

  return containsChild;
}

export default isDescendant;

